/* ANTIOX centered welcome film and opt-in client video playback. */
(() => {
  const welcome = document.querySelector('[data-welcome-video]');
  if (welcome) {
    const iframe = welcome.querySelector('.welcome-stage__video');
    const sound = welcome.querySelector('[data-welcome-sound]');
    const pause = welcome.querySelector('[data-welcome-pause]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection?.saveData === true;

    if (iframe && sound && pause && !reduceMotion && !saveData) {
      // Play muted in a full-opacity frame; the original still remains a motion-reduction fallback.
      iframe.src = iframe.dataset.src;
      let audible = false;
      let paused = false;
      const youtube = (func) => iframe.contentWindow?.postMessage(
        JSON.stringify({event: 'command', func, args: []}),
        'https://www.youtube-nocookie.com',
      );
      sound.addEventListener('click', () => {
        audible = !audible;
        youtube(audible ? 'unMute' : 'mute');
        if (audible) {
          youtube('playVideo');
          paused = false;
          pause.textContent = 'PAUSE VIDEO';
          pause.setAttribute('aria-pressed', 'false');
        }
        welcome.classList.add('is-interacted');
        const label = sound.querySelector('[data-welcome-sound-label]');
        if (label) label.textContent = audible ? 'TURN SOUND OFF' : 'TURN SOUND ON';
        sound.setAttribute('aria-label', audible ? 'Turn sound off for the ANTIOX welcome video' : 'Turn sound on for the ANTIOX welcome video');
        sound.setAttribute('aria-pressed', String(audible));
      });
      pause.addEventListener('click', () => {
        paused = !paused;
        youtube(paused ? 'pauseVideo' : 'playVideo');
        pause.textContent = paused ? 'PLAY VIDEO' : 'PAUSE VIDEO';
        pause.setAttribute('aria-pressed', String(paused));
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) youtube('pauseVideo');
        else if (!paused) youtube('playVideo');
      });
    } else {
      welcome.classList.add('welcome-motion-off');
      const controls = welcome.querySelector('.welcome-stage__controls');
      if (controls) controls.hidden = true;
    }
  }

  // Vimeo oEmbed resolves the ANTIOX vanity URL /ming/lindsey to video 865398376.
  const vimeoVanityIds = {'/ming/lindsey': '865398376'};
  let active = null;

  function stopActiveVideo() {
    if (!active) return;
    // Removing an iframe stops playback regardless of its provider or cookie settings.
    if (active.screen.isConnected) active.screen.replaceChildren(active.preview);
    active = null;
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.video-story-preview');
    if (!button) return;
    const story = button.closest('.video-story');
    const screen = button.closest('.nicky-feature__player') || button.closest('.video-story-screen');
    // Testimonials have no outbound anchor; the cleanse walkthrough retains its existing source.
    const source = story?.dataset.videoSrc || story?.querySelector('.video-story-source')?.href;
    if (!screen || !source) return;

    let url;
    try { url = new URL(source); } catch { return; }
    let embed = '';
    if (url.hostname === 'www.youtube.com' || url.hostname === 'youtube.com') {
      const id = url.searchParams.get('v') || url.pathname.match(/^\/shorts\/([\w-]{11})\/?$/)?.[1];
      if (id && /^[\w-]{11}$/.test(id)) {
        embed = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
      }
    } else if (url.hostname === 'vimeo.com' || url.hostname === 'www.vimeo.com') {
      const id = url.pathname.match(/^\/(\d+)\/?$/)?.[1] || vimeoVanityIds[url.pathname.toLowerCase()];
      if (id) embed = `https://player.vimeo.com/video/${id}?autoplay=1`;
    }

    stopActiveVideo();
    if (!embed) {
      // Unknown sources fail in place instead of opening an external website.
      const error = document.createElement('p');
      error.className = 'video-story-error';
      error.setAttribute('role', 'status');
      error.textContent = 'This video is unavailable right now. Please try again later.';
      screen.replaceChildren(error);
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.title = button.getAttribute('aria-label') || 'ANTIOX client video story';
    iframe.src = embed;
    iframe.loading = 'eager';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    active = {screen, preview: button};
    screen.replaceChildren(iframe);
  });
})();
